import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/logo-twitter.png'
import _imports_1 from '../images/logo-alibaba.png'
import _imports_2 from '../images/logo-youtube.png'
import _imports_3 from '../images/logo-email.png'
import _imports_4 from '../images/logo-facebook.png'
import _imports_5 from '../images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0f71f081"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "link-con" }
const _hoisted_3 = { class: "logo-link" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "OTIMES twitter"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "OTIMES alibaba"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "OTIMES youtube"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "OTIMES email"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "OTIMES facebook"
}, null, -1))
const _hoisted_9 = {
  class: "topbar",
  style: {"background-color":"#fff"}
}
const _hoisted_10 = { class: "container" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("HOME")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "COMPANY", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("About Us")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Our service")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("History")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("PRODUCTS")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("GLOBAL PRESENCE")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("PARTNERS")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("CAREER")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_link, {
            underline: false,
            href: "https://twitter.com/Otimes11",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_link, {
            underline: false,
            href: "https://otimes.en.alibaba.com",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_link, {
            underline: false,
            href: "https://www.youtube.com/channel/UC6yK4X18rd0h1xKDhkYs8-w",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_link, {
            underline: false,
            href: "javascript:void(0);",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/career.html')))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_link, {
            underline: false,
            href: "https://www.facebook.com/Eighth-Element-Environment-Technology-Co-Ltd-100322925983089",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("img", {
          class: "logo",
          src: _imports_5,
          alt: "OTIMES",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
        }),
        _createVNode(_component_el_menu, {
          "default-active": _ctx.$route.path,
          class: "el-menu-demo",
          mode: "horizontal",
          "text-color": "#001E6C",
          "active-text-color": "#4D92DA",
          router: true,
          onSelect: _ctx.select
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "/" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "2" }, {
              title: _withCtx(() => [
                _hoisted_12
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, {
                  style: {"font-size":"16px"},
                  index: "/about.html"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, {
                  style: {"font-size":"16px"},
                  index: "/service.html"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, {
                  style: {"font-size":"16px"},
                  index: "/history.html"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/products" }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/global.html" }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/partners.html" }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/career.html" }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active", "onSelect"])
      ])
    ])
  ], 64))
}